<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: flex-start;
      gap: 10px;
      overflow-x: auto;
      overflow-y: hidden;
    "
    :data-testid="getTestId('upload-footer')"
  >
    <UploadFooterDetail
      v-for="uploadId in activeUploadIds"
      :key="uploadId"
      :upload-id="uploadId"
      :data-testid="getTestId(`upload-footer-detail-${uploadId}`)"
    />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';
import { ref } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import UploadFooterDetail from '../uploadFooter/UploadFooterDetail.vue';

export default {
  name: 'UploadFooter',
  data: () => ({
    dialog: false,
    toggle: false,
    toggleerror: true,
    toggleref: ref(),
  }),
  computed: {
    ...mapGetters({
      activeUploadIds: 'uploadfile/activeUploadIds',
    })
  },
  watch: {
    activeUploadIds(newValue) {
      console.log('테스트 uploadFooter activeUploadIds:', newValue);
      for (const a in newValue) {
        console.log('테스트 uploadFooter activeUploadIds:', a);
      }
    }
  },
  methods: {
    ...mapActions({}),
    getTestId(testId) {
      return getTestId(testId);
    }
  },
  components: {
    UploadFooterDetail
  }
};
</script>

<style scoped>
.upload-snackbar {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
</style>
